import { createHistoryAccommodationDetailsQuery } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useHistoryAccommodationDetailsQuery = createHistoryAccommodationDetailsQuery(HTTP_CONFIG.API.Consumer.url)
